import {
  STORE_CartCheckoutData,
  STORE_SHEDULEDateNTime,
  STORE_MERCHANT_SCROLL,
  STORE_DineType,
  STORE_MERCHANT,
  STORE_Addons,
  STORE_Cart,
  ENTRY_MODE,
} from "../../database/store-names";
import {
  DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT,
  CONVERT_TIME_12TO24,
  GET_CART_COUNT,
} from "../../functions/funtion";
import {
  GET_CART_SELECT_MERCHATS_ZONE,
  GET_SET_STORED_DATA,
  GET_ADDON_UOM,
  GET_CART,
} from "../../database/get-stored-data";
import {
  SET_STORE_ADDONUOM,
  SET_STORE_PAGE_URL,
  SET_STORE_CART,
} from "../../database/store-data";
import {
  PT_PRODUCT_LIST,
  PT_PRODUCT,
  PT_HOME,
} from "../../routes/stack/paths/pt-home";
import {
  api_LoadDateTimeForScheduleOrder,
  api_CalculationSalesOrder,
} from "../../connection/api/api-cart";
import {
  set_dto_checkout_data_from_calculation_service,
  set_dto_selected_final_merchant_or_product,
  set_dto_selected_merchant_or_product,
  set_dto_Merchant,
} from "../../classes/dto-setters/dto-setter";
import {
  dto_selected_final_merchant_or_product,
  dto_selected_merchant_or_product,
} from "../../classes/dto-selected-merchant-or-product";
import {
  shouldUseLocalSalesOrderCalculation,
  calculateSalesOrderLocalWithDeliveryCharge,
} from "../../functions/local-order-calculation";
import { api_ValidateSalesOrderBeforePlacing } from "../../connection/api/api-checkout";
import { PT_ADDRESSLIST, PT_SIGNIN } from "../../routes/stack/paths/pt-profile";
import { dto_StartupPageLoadInfo } from "../../classes/dto-mobile-settings";
import { CSP, ENCRYPT_STORAGE } from "../../config/config";
import { PT_CART, PT_PAYMODE } from "../../routes/stack/paths/pt-cart";
import { dto_cart_checkout } from "../../classes/dto-cart-checkout";
import { F_Fammily, Font } from "../../util/config-fonts";
import { ToastMessage } from "../../components/toast-notification/toast";
import { dto_Merchant } from "../../classes/dto-merchant";
import { dto_Customer } from "../../classes/dto-customer";
import { dto_common } from "../../classes/dto-common";
import { Colors } from "../../util/colors";
import DrawerSheetBottom from "../../components/BottomDrawer/drawer-bottom";
import DisplayDineType from "./components/header/display-dine-type";
import DrawerShecule from "./components/shedule-details/drawershedule";
import CartItemList from "../../components/render-cart-item/render-drawer-cart";
import LaodAllPromo from "./components/promo/load-all-propmos";
import PriceDetail from "./components/price-details/priceDt";
import PlaceHolder from "../home/components/product-list-place-holder/product-list-place-holder";
import ConfirmBtn from "./components/confirm-btn/confirmbtn";
import Schedule from "./components/shedule-details/shedule";
import Address from "./components/address/address";
import NoteBox from "./components/note/note-box";
import Alert from "../../components/Alert";
import React from "react";
import Promo from "./components/promo/promo";

export default class Cart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataCart: [],
      LocalCart: [],
      GrandTotal: "",
      SubTotal: "",
      RowDiscountTotal: "",
      TotalTax: "",
      TotalServiceCharge: "",
      DiscountPercentage: "",
      DocDiscountTotal: "",
      DeliveryCharges: "",
      MinOrderValue: "",
      MaxOrderValue: "",
      NonDisplaySubTotal: "",
      DisplayDiscount: "",
      PromoGUID: "",
      PromoCode: "",
      PromoHeader: "",
      XMLTaxDoc: [],
      Error: "",
      PayMode: "",
      BankTransferAccountDetails: "",
      ProductPreparationError: "",
      ScheduleProductPrepareTime: 0,
      IPGUrl: "",
      Note: null,
      IPGUsername: "",
      IPGPassword: "",
      IPGMerchantNumber: "",
      CustomerPromoCount: "",
      VisibleSheduleOrder: false,
      SheduleDescription: "",
      SheduleTimes: [],
      SheduleDates: [],
      MerchantAllowInstanceOrder: false,
      SheduleMinimumDate: new Date(),
      SheduleNoOfDaystoshow: 0,
      SheduleOpen: false,
      IsReady: false,
      IsLoading: false,
      PromoDrawerOpen: false,
      ConfirmButtonDisable: true,
      isDeliverChargeApplyByMerchant: "True",
      isMerchantClosed: false,
      isExpanded: true,
      DiscountDeliveryCharges: "",
      CartMerchant: null,
    };
  }

  ensureValidDineType() {
    const storedDineType = ENCRYPT_STORAGE.getItem(STORE_DineType);
    const parsedStoredDineType = Number(storedDineType);
    const parsedDtoDineType = Number(dto_common.DineType);

    if (
      storedDineType !== undefined &&
      storedDineType !== null &&
      storedDineType !== "" &&
      storedDineType !== "undefined" &&
      !Number.isNaN(parsedStoredDineType)
    ) {
      dto_common.DineType = parsedStoredDineType;
      return dto_common.DineType;
    }

    if (!Number.isNaN(parsedDtoDineType)) {
      dto_common.DineType = parsedDtoDineType;
      return dto_common.DineType;
    }

    dto_common.DineType = 4;
    return dto_common.DineType;
  }

  async componentDidMount() {
    ENCRYPT_STORAGE.removeItem(STORE_MERCHANT_SCROLL);
    await GET_SET_STORED_DATA();
    const entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
    const isGuestUser =
      dto_Customer.CSID === 0 || dto_Customer.CSID === undefined;

    if (isGuestUser) {
      await SET_STORE_PAGE_URL(PT_CART);
      this.props.navigate(PT_SIGNIN);
      return;
    }

    if (dto_Customer.CSID !== 0) {
      if (dto_common.DeliveryZoneID === 0 || dto_common.DeliveryZoneID === "") {
        let SelectedDineType = Number(ENCRYPT_STORAGE.getItem(STORE_DineType));
        if (
          CSP === "DT" &&
          entryMode === "QR" &&
          SelectedDineType === 3
        ) {
        } else {
          this.props.navigate(PT_ADDRESSLIST.replace(":frompage", "cart"));
          await SET_STORE_PAGE_URL(PT_HOME);
          return;
        }
      }
    }
    if (dto_cart_checkout.Comment !== "") {
      this.setState({ Note: dto_cart_checkout.Comment });
    }
    this.ensureValidDineType();
    await this.LoadCartData();
    if (CSP === "MK") {
      await this.hardCodedScheduleOrderForMKB();
    } else {
      await this.SheduleOrder();
    }
  }

  async hardCodedScheduleOrderForMKB() {
    if (this.state.IsReady) {
      let data = await api_LoadDateTimeForScheduleOrder(
        this.state.ScheduleProductPrepareTime,
      );
      if (!data) {
        return;
      }

      let objdata;
      try {
        objdata = JSON.parse(data);
      } catch (error) {
        console.error("Invalid schedule API response", error, data);
        return;
      }

      if (objdata.Error === undefined) {
        var MinimumDate = objdata.Date;
        var NoOfDaystoshow = objdata.NoOfDays;
        var dates = [];
        for (let i = 0; i < NoOfDaystoshow; i++) {
          let date = new Date();
          date.setDate(date.getDate() + i);
          dates.push({
            Date: date.toISOString().split("T")[0],
          });
        }

        const hardCodedTimeSlots = [
          { timeSlot: "09.00 AM - 11.00 AM", expirationTime: "01.00 AM" },
          { timeSlot: "12.00 PM - 03.00 PM", expirationTime: "10.30 AM" },
          { timeSlot: "05.00 PM - 08.00 PM", expirationTime: "04.00 PM" },
        ];

        var arraytimes = [];
        var arraydates = [];
        const now = new Date();
        function parseTimeTo24Hour(dateString, timeString) {
          let hours, minutes;
          if (
            timeString.includes("AM") ||
            timeString.includes("PM") ||
            timeString.includes("a.m") ||
            timeString.includes("p.m")
          ) {
            const cleanTime = timeString.replace(/\s+/g, " ").trim();
            let meridianMatch = cleanTime.match(/(AM|PM)$/);
            if (!meridianMatch) {
              meridianMatch = cleanTime.match(/(a\.m|p\.m)$/);
            }

            const meridian = meridianMatch ? meridianMatch[1] : "";
            const timeOnly = cleanTime.replace(/(AM|PM|a\.m|p\.m)$/, "").trim();

            if (timeOnly.includes(".")) {
              const parts = timeOnly.split(".");
              hours = parseInt(parts[0]);
              minutes = parseInt(parts[1]);
            } else {
              hours = parseInt(timeOnly);
              minutes = 0;
            }

            if ((meridian === "PM" || meridian === "p.m") && hours !== 12)
              hours += 12;
            if ((meridian === "AM" || meridian === "a.m") && hours === 12)
              hours = 0;
          }

          const parsedDate = new Date(dateString);
          parsedDate.setHours(hours, minutes, 0, 0);
          return parsedDate;
        }

        for (let d = 0; d < dates.length; d++) {
          var date = dates[d].Date;
          var moddate = new Date(date);
          var loopdate = moddate.toDateString();
          arraydates.push(loopdate);

          for (let slot of hardCodedTimeSlots) {
            const dateString = new Date(loopdate).toDateString();
            const currentDateString = now.toDateString();

            let isValid = true;

            if (dateString === currentDateString) {
              const expirationDateTime = parseTimeTo24Hour(
                loopdate,
                slot.expirationTime,
              );
              isValid = now.getTime() < expirationDateTime.getTime();
            }

            if (isValid) {
              var makeArrayPush = {
                Datee: loopdate,
                Timee: slot.timeSlot,
              };
              arraytimes.push(makeArrayPush);
            }
          }
        }

        let ScheduleDate = dto_common.SCHEDULEDDATE;
        let ScheduleTime = dto_common.SCHEDULEDTIME;
        let isExpired = true;

        if (ScheduleDate && ScheduleTime) {
          const selectedSlotExpiration = hardCodedTimeSlots.find(
            (slot) => slot.timeSlot === ScheduleTime,
          );

          if (selectedSlotExpiration) {
            const selectedExpirationDate = parseTimeTo24Hour(
              ScheduleDate,
              selectedSlotExpiration.expirationTime,
            );
            isExpired = now.getTime() >= selectedExpirationDate.getTime();
          }
        }

        this.setState({
          SheduleDescription: "",
          VisibleSheduleOrder: true,
          SheduleOpen: isExpired,
          SheduleTimes: arraytimes,
          SheduleDates: arraydates,
          MerchantAllowInstanceOrder: objdata.MerchantAllowInstanceOrder,
          SheduleMinimumDate: MinimumDate,
          SheduleNoOfDaystoshow: NoOfDaystoshow,
        });
      } else {
        if (
          dto_common.SCHEDULEDDATE !== "" &&
          dto_common.SCHEDULEDTIME !== ""
        ) {
          this.setState({ VisibleSheduleOrder: true });
        } else {
          this.setState({ VisibleSheduleOrder: false });
        }
      }
    }
  }

  async SheduleOrder() {
    if (CSP === "AV" || CSP === "DT") {
      this.ensureValidDineType();
    }

    if (this.state.IsReady) {
      let data = await api_LoadDateTimeForScheduleOrder(
        this.state.ScheduleProductPrepareTime,
      );
      if (!data) {
        return;
      }

      let objdata;
      try {
        objdata = JSON.parse(data);
      } catch (error) {
        console.error("Invalid schedule API response", error, data);
        return;
      }

      if (objdata.Error === undefined) {
        var dates = objdata.LstDays;
        var MinimumDate = objdata.Date;
        var NoOfDaystoshow = objdata.NoOfDays;

        var arraytimes = [];
        var arraydates = [];
        for (let d = 0; d < dates.length; d++) {
          var date = dates[d].Date;

          var moddate = new Date(date);
          var loopdate = moddate.toDateString();
          var Times = dates[d].lstTime;
          arraydates.push(loopdate);
          var Maketime = "";
          var latestadjustabletime = Times[0];
          if (Times.length > 0) {
            for (let t = 1; t < Times.length; t++) {
              const adjustabletime = Times[t];
              Maketime = latestadjustabletime + " - " + adjustabletime;
              var makeArrayPush = { Datee: loopdate, Timee: Maketime };
              arraytimes.push(makeArrayPush);
              latestadjustabletime = adjustabletime;
            }
          }
        }

        const now = new Date();

        function parseTimeTo24Hour(dateString, timeString) {
          const [time, meridian] = timeString.split(" ");
          let [hours, minutes] = time.split(":").map(Number);
          if (meridian === "PM" && hours !== 12) hours += 12;
          if (meridian === "AM" && hours === 12) hours = 0;
          const parsedDate = new Date(dateString);
          parsedDate.setHours(hours, minutes, 0, 0);
          return parsedDate;
        }

        arraytimes = arraytimes.filter(({ Datee, Timee }) => {
          let noOfHours = 2;
          const dateString = new Date(Datee).toDateString();
          if (dateString === now.toDateString()) {
            const [startTime] = Timee.split(" - ");
            const startDateTime = parseTimeTo24Hour(Datee, startTime);
            return (
              startDateTime.getTime() >=
              now.getTime() + noOfHours * 60 * 60 * 1000
            );
          }
          return true;
        });

        this.setState(
          {
            SheduleDescription: "",
            VisibleSheduleOrder: true,
            SheduleTimes: arraytimes,
            SheduleDates: arraydates,
            MerchantAllowInstanceOrder: objdata.MerchantAllowInstanceOrder,
            SheduleMinimumDate: MinimumDate,
            SheduleNoOfDaystoshow: NoOfDaystoshow,
          },
          async () => {
            if (
              dto_common.SCHEDULEDTIME !== "" &&
              dto_common.SCHEDULEDDATE !== ""
            ) {
              let Selected_Time = dto_common.SCHEDULEDTIME.split("-");
              let Split_SelectedTime = CONVERT_TIME_12TO24(
                Selected_Time[0].trim(),
              ).split(":");
              let SelectedHours = parseInt(Split_SelectedTime[0].trim());
              let SelectedMinutes = parseInt(Split_SelectedTime[1].trim());
              let SeletedDate = new Date(dto_common.SCHEDULEDDATE);

              SeletedDate.setHours(SelectedHours);
              SeletedDate.setMinutes(SelectedMinutes);
              let CurrentDate = new Date();
              if (CurrentDate.getTime() > SeletedDate.getTime()) {
                dto_common.SCHEDULEDDATE = "";
                dto_common.SCHEDULEDTIME = "";
                ENCRYPT_STORAGE.removeItem(STORE_SHEDULEDateNTime);
                this.setState({ SheduleOpen: true });
                await DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT(async () => {
                  this.setState({ SheduleOpen: false });
                  await this.SheduleOrder();
                });
              }
            }
            if (
              dto_common.SCHEDULEDTIME === "" &&
              dto_common.SCHEDULEDDATE === ""
            ) {
              dto_common.SCHEDULEDDATE = "";
              dto_common.SCHEDULEDTIME = "";
              ENCRYPT_STORAGE.removeItem(STORE_SHEDULEDateNTime);
              this.setState({ SheduleOpen: true });
              await DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT(async () => {
                this.setState({ SheduleOpen: false });
                await this.SheduleOrder();
              });
            }
          },
        );
      } else {
        if (
          dto_common.SCHEDULEDDATE !== "" &&
          dto_common.SCHEDULEDTIME !== ""
        ) {
          this.setState({ VisibleSheduleOrder: true });
        } else {
          this.setState({ VisibleSheduleOrder: false });
        }
      }
    }
  }

  onNoteChange(value) {
    if (value.indexOf("\n") === -1) {
    } else {
      return;
    }
    if (value === "") {
      this.setState({
        Note: "",
      });
    } else {
      this.setState({
        Note: value,
      });
    }
    dto_cart_checkout.Comment = value;
  }

  async LoadCartData(IsChangedPromo = false) {
    GET_CART_COUNT();
    if (CSP === "AV" || CSP === "DT") {
      this.ensureValidDineType();
    }

    let LocalCart = await GET_CART();
    const isCartConsistent =
      await this.validateCartMerchantConsistency(LocalCart);
    if (!isCartConsistent) {
      this.setState({
        IsReady: false,
        IsLoading: false,
        LocalCart: [],
        dataCart: [],
      });
      return;
    }

    let SelectedDineType = Number(ENCRYPT_STORAGE.getItem(STORE_DineType));
    const hasSelectedDineType = !Number.isNaN(SelectedDineType);
    if (LocalCart === undefined || LocalCart.length === 0) {
      this.setState({ IsReady: false });
      return;
    } else {
      const storedCartMerchant = await GET_CART_SELECT_MERCHATS_ZONE();
      this.setState({ IsLoading: true, IsReady: true });
      if (storedCartMerchant) {
        this.setState({ CartMerchant: storedCartMerchant });
      }
      const merchants = ENCRYPT_STORAGE.getItem(STORE_MERCHANT) || [];
      const currentMerchant =
        merchants.find &&
        merchants.find(
          (merchant) =>
            parseInt(merchant.MID) ===
            parseInt(dto_selected_final_merchant_or_product.MID),
        );
      const useLocalCalculation = shouldUseLocalSalesOrderCalculation();
      let data = useLocalCalculation
        ? await calculateSalesOrderLocalWithDeliveryCharge({
            cart: LocalCart,
            merchant:
              currentMerchant || dto_Merchant || storedCartMerchant || {},
            isChangePromo: IsChangedPromo,
            customerPromoCount: this.state.CustomerPromoCount,
          })
        : await api_CalculationSalesOrder(
            JSON.stringify(LocalCart),
            IsChangedPromo,
          );
      let responseText = "";
      let isJsonData = false;
      let parsedCalculationResponse = null;

      if (Array.isArray(data) || (data && typeof data === "object")) {
        parsedCalculationResponse = data;
        isJsonData = true;
      } else {
        const normalizedResponse =
          typeof data === "string" ? data.trim() : String(data ?? "");
        responseText = normalizedResponse;
        if (
          normalizedResponse.startsWith('"') &&
          normalizedResponse.endsWith('"')
        ) {
          try {
            const unwrappedResponse = JSON.parse(normalizedResponse);
            if (typeof unwrappedResponse === "string") {
              responseText = unwrappedResponse;
            }
          } catch (error) {}
        }

        isJsonData =
          responseText.startsWith("[") || responseText.startsWith("{");
        if (isJsonData) {
          try {
            parsedCalculationResponse = JSON.parse(responseText);
          } catch (error) {
            isJsonData = false;
          }
        }
      }

      if (isJsonData && SelectedDineType === 4 && CSP === "AV") {
        let objresponce = parsedCalculationResponse;
        let hasDeliveryCharge = false;
        const cartObj = objresponce[0];
        let cartItems = cartObj[0];

        for (let i = 0; i < cartItems.length; i++) {
          if (cartItems[i].TID === 5) {
            hasDeliveryCharge = true;
            break;
          }
        }

        if (!hasDeliveryCharge) {
          this.setState({ ConfirmButtonDisable: true }, () => {
            // Alert.MessageBox({
            //   Tittle: "Info",
            //   ConfirmButtonText: "Ok",
            //   Text: "Something went wrong",
            // });
            ToastMessage(1, "Something went wrong");

            this.setState({
              LocalCart: [],
              dataCart: [],
              GrandTotal: dto_StartupPageLoadInfo.Currency + " 0.00",
              SubTotal: dto_StartupPageLoadInfo.Currency + " 0.00",
              INTSubTotal: 0,
              TotalTax: dto_StartupPageLoadInfo.Currency + " 0.00",
              TotalServiceCharge: dto_StartupPageLoadInfo.Currency + " 0.00",
              DiscountPercentage: dto_StartupPageLoadInfo.Currency + " 0.00",
              DocDiscountTotal: dto_StartupPageLoadInfo.Currency + " 0.00",
              DeliveryCharges: dto_StartupPageLoadInfo.Currency + " 0.00",
              DiscountDeliveryCharges:
                dto_StartupPageLoadInfo.Currency + " 0.00",
            });
          });
        }
      }

      if (isJsonData || responseText !== "") {
        if (responseText === "PRODUCT AND MERCHANT MISMATCH..!") {
          Alert.MessageBox({
            Tittle: "INFO",
            Text: "PRODUCT AND MERCHANT MISMATCH..!",
            ConfirmButtonText: "OK",
            ConfirmButtonFunction: async () => {
              await this.ClearCardData();
              this.props.navigate(PT_CART);
            },
          });
        } else if (
          responseText ===
          "INVALID DATE..! PLEASE SELECT ANOTHER DATE AND TIME SLOT..!"
        ) {
          Alert.MessageBox({
            Tittle: "INFO",
            Text: "INVALID DATE..! PLEASE SELECT ANOTHER DATE AND TIME SLOT..!",
            ConfirmButtonText: "OK",
            ConfirmButtonFunction: async () => {
              dto_common.SCHEDULEDDATE = "";
              dto_common.SCHEDULEDTIME = "";
              ENCRYPT_STORAGE.removeItem(STORE_SHEDULEDateNTime);
              window.location.reload();
            },
          });
        } else if (
          responseText ===
          "SORRY SELECTED SCHEDULED TIME SLOT NOT AVAILABLE. PLEASE SELECT ANOTHER TIME SLOT..!"
        ) {
          Alert.MessageBox({
            Tittle: "INFO",
            Text: "SORRY SELECTED SCHEDULED TIME SLOT NOT AVAILABLE. PLEASE SELECT ANOTHER TIME SLOT..!",
            ConfirmButtonText: "OK",
            ConfirmButtonFunction: async () => {
              dto_common.SCHEDULEDDATE = "";
              dto_common.SCHEDULEDTIME = "";
              ENCRYPT_STORAGE.removeItem(STORE_SHEDULEDateNTime);
              window.location.reload();
            },
          });
        } else if (responseText === "SORRY MERCHANT CLOSED..!") {
          Alert.MessageBox({
            Tittle: "INFO",
            Text: "SORRY MERCHANT CLOSED..!",
            ConfirmButtonText: "OK",
            ConfirmButtonFunction: async () => {
              await this.ClearCardData();
              await GET_CART_COUNT();
              this.setState({
                IsReady: false,
                IsLoading: false,
                LocalCart: [],
                dataCart: [],
                ConfirmButtonDisable: true,
                isMerchantClosed: true,
                isDeliverChargeApplyByMerchant: "False",
              });
            },
          });
        } else {
          if (!isJsonData || !parsedCalculationResponse) {
            this.setState({ ConfirmButtonDisable: true }, () => {
              ToastMessage(3, responseText || "Something went wrong");
            });
            return;
          }
          let objresponce = parsedCalculationResponse;
          const findByKey = (key) =>
            objresponce.find((item) => item && Object.keys(item)[0] === key);

          const cartObj = objresponce[0];
          const grandTotalObj = findByKey("GrandTotal");
          const subTotalObj = findByKey("SubTotal");
          const nonDisplaySubTotalObj = findByKey("NonDisplaySubTotal");
          const taxObj = findByKey("TotalTax");
          const serviceChargeObj = findByKey("TotalServiceCharge");
          const discountObj = findByKey("DiscountPercentage");
          const displayDiscountObj = findByKey("DisplayDiscount");
          const deliveryObj = findByKey("DeliveryCharges");
          const minOrderObj = findByKey("MinOrderValue");
          const maxOrderObj = findByKey("MaxOrderValue");
          const promoGuidObj = findByKey("PromoGUID");
          const promoCodeObj = findByKey("PromoCode");
          const promoHeaderObj = findByKey("PromoHeader");
          const errorObj = findByKey("Error");
          const prodPrepErrObj = findByKey("ProductPreparationError");
          const schedPrepTimeObj = findByKey("ScheduleProductPrepareTime");
          const promoCountObj = findByKey("CustomerPromoCount");
          const isDeliverChargeApplyObj = findByKey(
            "isDeliverChargeApplyByMerchant",
          );
          const merchantDineTypeObj = findByKey("MerchantDineType");
          const discountDelvObj = findByKey("DiscountDeliveryCharges");

          this.setState({
            LocalCart,
            dataCart: cartObj[0],

            GrandTotal:
              dto_StartupPageLoadInfo.Currency +
              " " +
              grandTotalObj?.GrandTotal,
            SubTotal:
              dto_StartupPageLoadInfo.Currency + " " + subTotalObj?.SubTotal,
            INTSubTotal: subTotalObj?.SubTotal,
            TotalTax: dto_StartupPageLoadInfo.Currency + " " + taxObj?.TotalTax,
            TotalServiceCharge:
              dto_StartupPageLoadInfo.Currency +
              " " +
              serviceChargeObj?.TotalServiceCharge,

            DiscountPercentage:
              dto_StartupPageLoadInfo.Currency +
              " " +
              discountObj?.DiscountPercentage,
            DocDiscountTotal:
              dto_StartupPageLoadInfo.Currency +
              " " +
              displayDiscountObj?.DisplayDiscount,

            DeliveryCharges:
              dto_StartupPageLoadInfo.Currency +
              " " +
              deliveryObj?.DeliveryCharges,
            MinOrderValue: minOrderObj?.MinOrderValue?.replace(
              /[^0-9.-]+/g,
              "",
            ),
            MaxOrderValue: maxOrderObj?.MaxOrderValue?.replace(
              /[^0-9.-]+/g,
              "",
            ),

            NonDisplaySubTotal:
              nonDisplaySubTotalObj?.NonDisplaySubTotal?.replace(
                /[^0-9.-]+/g,
                "",
              ),

            PromoCode:
              parseInt(promoGuidObj?.PromoGUID) === 0
                ? "Add Promo"
                : promoCodeObj?.PromoCode,

            PromoHeader:
              parseInt(promoGuidObj?.PromoGUID) === 0
                ? ""
                : promoHeaderObj?.PromoHeader + " - ",

            Error: errorObj?.Error,
            ProductPreparationError: prodPrepErrObj?.ProductPreparationError,
            ScheduleProductPrepareTime:
              schedPrepTimeObj?.ScheduleProductPrepareTime,

            CustomerPromoCount: promoCountObj?.CustomerPromoCount,
            isDeliverChargeApplyByMerchant:
              isDeliverChargeApplyObj?.isDeliverChargeApplyByMerchant,

            DiscountDeliveryCharges:
              discountDelvObj?.DiscountDeliveryCharges === undefined
                ? dto_StartupPageLoadInfo.Currency + " 0.00"
                : dto_StartupPageLoadInfo.Currency +
                  " " +
                  discountDelvObj.DiscountDeliveryCharges,

            ConfirmButtonDisable: false,
            IsLoading: false,
          });

          if (CSP !== "MK") {
            const SelectedDineType = Number(
              ENCRYPT_STORAGE.getItem(STORE_DineType),
            );
            const parsedMerchantDineType = Number(
              merchantDineTypeObj?.MerchantDineType,
            );
            if (!Number.isNaN(SelectedDineType)) {
              dto_common.DineType = SelectedDineType;
            } else if (!Number.isNaN(parsedMerchantDineType)) {
              dto_common.DineType = parsedMerchantDineType;
            } else {
              dto_common.DineType = 4;
            }
          }
          await set_dto_checkout_data_from_calculation_service(objresponce);
        }
      } else {
        this.setState({ ConfirmButtonDisable: true }, () => {
          // Alert.MessageBox({
          //   Tittle: "Info",
          //   ConfirmButtonText: "Ok",
          //   Text: "Something went wrong",
          // });

          ToastMessage(3, "Something went wrong");
        });
      }

      if (isJsonData && hasSelectedDineType && SelectedDineType === 4) {
        let objresponce = parsedCalculationResponse;
        let hasDeliveryCharge = false;
        const cartObj = objresponce[0];
        let cartItems = cartObj[0];

        for (let i = 0; i < cartItems.length; i++) {
          if (cartItems[i].TID === 5) {
            hasDeliveryCharge = true;
            break;
          }
        }

        if (!hasDeliveryCharge) {
          this.setState({ ConfirmButtonDisable: true }, () => {
            // Alert.MessageBox({
            //   Tittle: "Info",
            //   ConfirmButtonText: "Ok",
            //   Text: "Something went wrong",
            // });

            ToastMessage(1, "Something went wrong");
          });
        }
      }

      this.setState({
        IsLoading: false,
        isDeliverChargeApplyByMerchant: "False",
      });
    }
  }

  async NavigateToPayMode() {
    const entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
    if (CSP === "DT" && entryMode === "QR") {
      this.setState({ IsLoading: false });
      this.props.navigate(PT_PAYMODE);
      return;
    }
    this.setState({ IsLoading: true }, async () => {
      let data = await api_ValidateSalesOrderBeforePlacing();
      if (JSON.parse(data) === "SUCCESS") {
        this.setState({ IsLoading: false });
        this.props.navigate(PT_PAYMODE);
      } else {
        if (data === '"SORRY MERCHANT CLOSED...!"') {
          this.setState({
            IsLoading: false,
            ConfirmButtonDisable: true,
            isMerchantClosed: true,
          });
        } else {
          this.setState({ IsLoading: false });
        }
        Alert.MessageBox({
          ConfirmButtonText: "OK",
          Icon: "warnig",
          Text: data,
          Tittle: "Info",
          ConfirmButtonFunction: async () => {
            if (data === '"SORRY MERCHANT CLOSED...!"') {
              this.setState({
                ConfirmButtonDisable: true,
                isMerchantClosed: true,
              });
            }
          },
        });
        return;
      }
    });
  }

  async SetPromo(item) {
    this.setState({ PromoHeader: item.PromoHeading + " - " });
    if (
      parseFloat(item.MinOrderValue) >=
      parseFloat(dto_cart_checkout.DisplaySubtotal)
    ) {
      // Alert.MessageBox({
      //   Tittle: "Message",
      //   Text:
      //     "Promo code cannot be apply. Minimum order value must be above" +
      //     " " +
      //     dto_StartupPageLoadInfo.Currency +
      //     " " +
      //     item.MinOrderValue +
      //     " ",
      //   ConfirmButtonText: "Ok",
      //   Icon: "info",
      // });

      ToastMessage(
        1,
        "Promo code cannot be apply. Minimum order value must be above" +
          " " +
          dto_StartupPageLoadInfo.Currency +
          " " +
          item.MinOrderValue +
          " ",
      );

      return;
    } else if (
      parseFloat(item.DiscAmount) >=
      parseFloat(dto_cart_checkout.DisplaySubtotal)
    ) {
      // Alert.MessageBox({
      //   Tittle: "Message",
      //   Text:
      //     "Promo code cannot be apply. Minimum order value must be above" +
      //     " " +
      //     dto_StartupPageLoadInfo.Currency +
      //     " " +
      //     item.DiscAmount +
      //     " ",
      //   ConfirmButtonText: "Ok",
      //   Icon: "info",
      // });

      ToastMessage(
        1,
        "Promo code cannot be apply. Minimum order value must be above" +
          " " +
          dto_StartupPageLoadInfo.Currency +
          " " +
          item.DiscAmount +
          " ",
      );
      return;
    } else {
      dto_cart_checkout.PromoHeader = item.PromoHeading || "";
      dto_cart_checkout.PromoGuid = item.GUID;
      dto_cart_checkout.PromoCODE = item.PromoCode || "";
      dto_cart_checkout.DiscountPersentage =
        parseFloat(item.DiscPercentage) || 0;
      dto_cart_checkout.DiscountTotal = parseFloat(item.DiscAmount) || 0;
      this.setState({ PromoDrawerOpen: false });
      await this.LoadCartData(false);
    }
  }

  async Delete(i, LineID, AddonLineId) {
    let dataCart = this.state.LocalCart;
    let PID = dataCart[i].LineID;
    let ProductName = dataCart[i].Desc;
    if (LineID === PID) {
      let LocalCart = await GET_CART();
      if (LocalCart !== undefined && LocalCart.length > 0) {
        Alert.ConfirmationMessageBox({
          ConfirmButtonFunction: async () => {
            let ADDonUOMList = await GET_ADDON_UOM();
            if (dataCart.length === 1) {
              dto_common.SCHEDULEDDATE = "";
              dto_common.SCHEDULEDTIME = "";
              ENCRYPT_STORAGE.removeMultipleItems([
                STORE_Cart,
                STORE_Addons,
                STORE_SHEDULEDateNTime,
              ]);
              dataCart = [];
              await this.LoadCartData();
              return;
            } else {
              dataCart.splice(i, 1);
              if (ADDonUOMList !== undefined) {
                if (ADDonUOMList.length > 0 && ADDonUOMList !== undefined) {
                  for (var k = 0; k < ADDonUOMList.length; k++) {
                    if (AddonLineId === ADDonUOMList[k].LINEID) {
                      ADDonUOMList.splice(k, 1);
                    }
                  }
                }
              }
            }

            if (dataCart.length > 0) {
              for (var j = 0; j < dataCart.length; j++) {
                dataCart[j].LineID = j + 1;
              }
            }
            await SET_STORE_CART(dataCart);
            await SET_STORE_ADDONUOM(ADDonUOMList);
            this.setState({ LocalCart: dataCart, loading: false });
            await this.LoadCartData();
          },
          ConfirmButtonText: "Yes",
          DismissButtonFunction: () => {},
          Icon: "info",
          Text:
            "Do you want to remove <b>" + ProductName + "</b> from your cart?",
          Tittle: "",
        });
      }
    }
  }

  async ClearCardData() {
    dto_cart_checkout.PromoHeader = "";
    dto_cart_checkout.PromoGuid = 0;
    dto_cart_checkout.PromoCODE = "";
    dto_cart_checkout.DiscountPersentage = 0;
    dto_cart_checkout.DiscountTotal = 0;
    dto_cart_checkout.Comment = "";
    dto_common.SCHEDULEDDATE = "";
    dto_common.SCHEDULEDTIME = "";

    ENCRYPT_STORAGE.removeMultipleItems([
      STORE_SHEDULEDateNTime,
      STORE_CartCheckoutData,
      STORE_Addons,
      STORE_Cart,
    ]);
  }

  async validateCartMerchantConsistency(localCart) {
    if (localCart === undefined || localCart.length === 0) {
      return true;
    }

    const uniqueMerchantIds = [
      ...new Set(localCart.map((item) => Number(item.MID))),
    ];
    if (uniqueMerchantIds.length > 1) {
      await this.ClearCardData();
      await GET_CART_COUNT();
      Alert.MessageBox({
        Tittle: "INFO",
        Text: "PRODUCT AND MERCHANT MISMATCH..!",
        ConfirmButtonText: "OK",
      });
      return false;
    }

    const cartMerchant = await GET_CART_SELECT_MERCHATS_ZONE();
    const cartMid = Number(uniqueMerchantIds[0]);
    const storedCartMid = Number(cartMerchant?.MID);
    if (
      cartMerchant !== undefined &&
      cartMerchant !== null &&
      !Number.isNaN(storedCartMid) &&
      storedCartMid > 0 &&
      storedCartMid !== cartMid
    ) {
      await this.ClearCardData();
      await GET_CART_COUNT();
      Alert.MessageBox({
        Tittle: "INFO",
        Text: "PRODUCT AND MERCHANT MISMATCH..!",
        ConfirmButtonText: "OK",
      });
      return false;
    }

    return true;
  }

  async ClearCart() {
    Alert.ConfirmationMessageBox({
      ConfirmButtonFunction: async () => {
        await this.ClearCardData();
        await this.LoadCartData();
      },
      ConfirmButtonText: "Yes",
      DismissButtonFunction: () => {},
      Icon: "Confirm",
      Text: "Are you sure you want to Clear the cart?",
      Tittle: "Clear Your Cart",
    });
  }

  async NavigateToProdcut(item) {
    this.props.navigate(
      PT_PRODUCT.replace(":frompage", "cart")
        .replace(":navigatepage", "cart")
        .replace(":category", "category")
        .replace(":pid", item.PID)
        .replace(":lineid", item.LineID)
        .replace(":adonlineid", item.ADDONLINEID)
        .replace(":isrecommended", 0),
    );
  }

  toggleParagraph = () => {
    this.setState((prevState) => ({
      isExpanded: !prevState.isExpanded,
    }));
  };

  navigateToCartMerchantProductList = async () => {
    // Always restore selected merchant context to the cart merchant before navigating.
    const storedCartMerchant = await GET_CART_SELECT_MERCHATS_ZONE();
    const cartMerchant = {
      ...(storedCartMerchant || dto_selected_final_merchant_or_product),
      CATID:
        CSP === "MK" &&
        ((storedCartMerchant || dto_selected_final_merchant_or_product)
          .CATID === 0 ||
          (storedCartMerchant || dto_selected_final_merchant_or_product)
            .CATID === undefined)
          ? Number(localStorage.getItem("firstCATID")) || 1
          : (storedCartMerchant || dto_selected_final_merchant_or_product)
              .CATID,
    };
    await set_dto_Merchant(cartMerchant);
    await set_dto_selected_final_merchant_or_product(cartMerchant);
    await set_dto_selected_merchant_or_product(cartMerchant);
    this.props.navigate(
      PT_PRODUCT_LIST.replace(":navPage", "cart").replace(":isSec", "false"),
    );
  };

  render() {
    let DineType = Number(ENCRYPT_STORAGE.getItem(STORE_DineType));
    let entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
    const { isExpanded } = this.state;
    const shouldPromptLoginForCart =
      this.state.IsReady &&
      this.state.LocalCart.length > 0 &&
      (dto_Customer.CSID === 0 || dto_Customer.CSID === undefined);
    const cartMerchant =
      this.state.CartMerchant || dto_selected_final_merchant_or_product;
    const cartMerchantLogo =
      cartMerchant.ImageURL ||
      dto_selected_merchant_or_product.ImageURL ||
      dto_Merchant.ImageURL ||
      dto_common.DefaultImageUrl;
    return (
      <div
        style={{
          paddingLeft: 10,
          paddingRight: 10,
          backgroundColor: "rgb(255, 255, 255)",
          paddingBottom: "10px",
        }}
      >
        {!this.state.IsReady ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              paddingTop: "100px",
            }}
          >
            <img
              src={require("../orders/components/orders-view/NoDataFound.jpg")}
              width={"60%"}
              alt=""
            />

            <label
              style={{
                fontWeight: "bold",
                marginBottom: "8px",
                textAlign: "center",
              }}
            >
              Your cart is empty
            </label>
            <label
              style={{
                textAlign: "center",
                display: "block",
              }}
            >
              Try adding something to the cart
            </label>

            <div
              style={{
                fontWeight: "bold",
                marginTop:
                  entryMode === "QR" ? "15px" : "120px",
                textAlign: "center",
                backgroundColor: Colors.DarkGreyScale,
                color: "white",
                padding: 15,
                borderRadius: "10px",
              }}
              onClick={() => {
                if (
                  CSP === "DT" &&
                  entryMode === "QR"
                ) {
                  this.props.navigate(
                    PT_PRODUCT_LIST.replace(":navPage", "none").replace(
                      ":isSec",
                      "false",
                    ),
                  );
                } else {
                  this.props.navigate(PT_HOME);
                }
              }}
            >
              Shop Now
            </div>
          </div>
        ) : shouldPromptLoginForCart ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              paddingTop: "100px",
              textAlign: "center",
            }}
          >
            <img
              src={require("../orders/components/orders-view/NoDataFound.jpg")}
              width={"60%"}
              alt=""
            />
            <label
              style={{
                fontWeight: "bold",
                marginBottom: "8px",
                textAlign: "center",
              }}
            >
              Sign in to view your cart
            </label>
            <label
              style={{
                textAlign: "center",
                display: "block",
                maxWidth: "280px",
              }}
            >
              Your cart items are saved. Log in to continue with checkout.
            </label>
            <div
              style={{
                fontWeight: "bold",
                marginTop: "30px",
                textAlign: "center",
                backgroundColor: Colors.DarkGreyScale,
                color: "white",
                padding: 15,
                borderRadius: "10px",
                cursor: "pointer",
                minWidth: "220px",
              }}
              onClick={async () => {
                await SET_STORE_PAGE_URL(PT_CART);
                this.props.navigate(PT_SIGNIN);
              }}
            >
              Login to View Cart
            </div>
          </div>
        ) : (
          <div style={{}}>
            {/* <div style={{ display: "block" }}>
              <MerchantName />
            </div> */}

            {/* Shop More */}
            {/* {CSP === "AV" ? null : (
              <BackToShop navigate={this.props.navigate} />
            )} */}

            {/* Dine Type */}
            <div
              style={{
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
                backgroundColor: "white",
                margin: "10px 1px 2px 1px",
                padding: "8px",
              }}
            >
              <DisplayDineType />

              {dto_common.DineType === 4 ? (
                <Address navigate={this.props.navigate} />
              ) : null}
            </div>

            {this.state.IsLoading ? (
              <PlaceHolder />
            ) : (
              <>
                {/* Schedule Date & Time */}
                {this.state.VisibleSheduleOrder ? (
                  <div
                    style={{
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
                      backgroundColor: "white",
                      paddingTop: "5px",
                      paddingBottom: "2px",
                    }}
                    onClick={() => {
                      this.setState({ SheduleOpen: true });
                    }}
                  >
                    <Schedule
                      SheduleDesc={this.state.SheduleDescription}
                      onClick={() => {
                        this.setState({ SheduleOpen: true });
                      }}
                    />
                  </div>
                ) : null}

                {/* Order Summary */}
                <div
                  style={{
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
                    backgroundColor: "white",
                    margin: "2px 1px",
                    padding: "8px",
                  }}
                >
                  {/* <div
                    style={{
                      marginTop: "5px",
                      marginLeft: "10px",
                      fontWeight: "bold",
                      fontSize: 18,
                      textAlign: "center",
                      width: "95%",
                    }}
                  >
                    {" "}
                    ORDER SUMMARY{" "}
                  </div> */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: 20,
                      paddingLeft: "5px",
                    }}
                  >
                    <div
                      onClick={async () => {
                        await this.navigateToCartMerchantProductList();
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <img
                          src={cartMerchantLogo}
                          onError={(e) => {
                            e.currentTarget.src = dto_common.DefaultImageUrl;
                          }}
                          alt=""
                          style={{
                            height: "60px",
                            width: "60px",
                            marginLeft: "5px",
                            borderRadius: "50%",
                            border: "1px solid #ccc",
                          }}
                        />
                        <div>
                          <div style={{ fontSize: 15, fontWeight: "bold" }}>
                            {cartMerchant.Merchant}
                          </div>
                          <div style={{ fontSize: 12 }}>
                            {this.state.LocalCart.length} Items
                          </div>
                        </div>
                      </div>
                    </div>
                    <i
                      className={`bi ${
                        isExpanded
                          ? "bi-caret-down-fill"
                          : "bi-caret-right-fill"
                      }`}
                      aria-hidden="true"
                      style={{
                        fontSize: "18px",
                        marginTop: "5px",
                        marginRight: "10px",
                        cursor: "pointer",
                      }}
                      onClick={this.toggleParagraph}
                    />
                  </div>

                  {isExpanded && (
                    <>
                      {this.state.dataCart.map((rs, i) => (
                        <CartItemList
                          key={rs.PID + "Cart" + i}
                          item={rs}
                          index={i}
                          NavigateToProductPage={async (item) => {
                            if (CSP === "AV" && item.PID === 1224929) {
                              return;
                            } else {
                              await this.NavigateToProdcut(item);
                            }
                          }}
                          RemoveItemFromCart={async (
                            i,
                            LineID,
                            AddonLineId,
                            item,
                          ) => {
                            if (CSP === "AV" && item.PID === 1224929) {
                              return;
                            } else {
                              await this.Delete(i, LineID, AddonLineId);
                            }
                          }}
                        />
                      ))}

                      {/* Back to Shop button */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginRight: "10px",
                          fontWeight: "bold",
                          padding: "10px",
                          margin: "5px",
                          marginTop: "10px",
                          boxSizing: "border-box",
                        }}
                        onClick={async () => {
                          await this.navigateToCartMerchantProductList();
                        }}
                      >
                        <i
                          className="bi bi-plus-circle-fill"
                          aria-hidden="true"
                          style={{ marginRight: "10px" }}
                        />
                        Add Item
                      </div>
                    </>
                  )}
                </div>

                {dto_selected_final_merchant_or_product.MID === 6 &&
                CSP !== "AV" ? (
                  <div
                    style={{
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
                      backgroundColor: "white",
                      margin: "0px 1px",
                    }}
                  >
                    <NoteBox />
                  </div>
                ) : null}

                <div
                  style={{
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
                    backgroundColor: "white",
                    margin: "2px 1px",
                    padding: "8px",
                  }}
                  onClick={() => {
                    this.setState({ PromoDrawerOpen: true }, async () => {
                      await DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT(() => {
                        this.setState({ PromoDrawerOpen: false });
                      }, "LaodAllPromoCloseButton");
                    });
                  }}
                >
                  <Promo
                    CustomerPromoCount={this.state.CustomerPromoCount}
                    PromoCode={this.state.PromoCode}
                    PromoHeader={this.state.PromoHeader}
                    PromoRemove={() => {
                      dto_cart_checkout.PromoHeader = "";
                      dto_cart_checkout.PromoGuid = 0;
                      dto_cart_checkout.PromoCODE = "";
                      dto_cart_checkout.DiscountPersentage = 0;
                      dto_cart_checkout.DiscountTotal = 0;
                      this.setState({ PromoCode: "No promotions applied" });
                      this.LoadCartData(true);
                    }}
                    PromoAdd={() => {
                      this.setState({ PromoDrawerOpen: true }, async () => {
                        await DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT(() => {
                          this.setState({ PromoDrawerOpen: false });
                        }, "LaodAllPromoCloseButton");
                      });
                    }}
                  />
                </div>

                <div
                  style={{
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
                    backgroundColor: "white",
                    margin: "2px 1px",
                    padding: "8px",
                    marginBottom: "60px",
                    paddingBottom: "20px",
                  }}
                >
                  <PriceDetail
                    SubTotal={this.state.SubTotal}
                    Discount={this.state.DocDiscountTotal}
                    ServiceCharge={this.state.TotalServiceCharge}
                    DeliveryCharge={this.state.DeliveryCharges}
                    DeliveryDiscount={this.state.DiscountDeliveryCharges}
                    TotalTax={this.state.TotalTax}
                    GrandTotal={this.state.GrandTotal}
                    Clear={async () => {
                      await this.ClearCart();
                    }}
                  />

                  {/* <hr
                    className="HR_LINE"
                    style={{
                      height: "2px",
                      border: "none",
                      background: "#ccc",
                      // boxShadow: "0px 4px 10px rgba(128, 128, 128, 0.7)",
                      margin: "0",
                    }}
                  />

                  {dto_common.DineType === 4 ? (
                    <Address navigate={this.props.navigate} />
                  ) : null} */}

                  <hr
                    className="HR_LINE"
                    style={{
                      height: "2px",
                      border: "none",
                      background: "#ccc",
                      boxShadow: "0px 4px 10px rgba(128, 128, 128, 0.7)",
                      margin: "0",
                    }}
                  />

                  {this.state.isDeliverChargeApplyByMerchant === "True" &&
                  DineType === 4 ? (
                    <>
                      <p
                        style={{
                          color: "red",
                          fontWeight: "bold",
                          textAlign: "center",
                        }}
                      >
                        Note: Delivery of this order will be conducted and
                        charged separately by {cartMerchant.Merchant}
                      </p>
                      <hr className="HR_LINE" />
                    </>
                  ) : (
                    ""
                  )}

                  {this.state.ConfirmButtonDisable ? (
                    ""
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          padding: "0 5px",
                          boxSizing: "border-box",
                        }}
                      >
                        <ConfirmBtn
                          navigate={this.props.navigate}
                          MaxOrderValue={this.state.MaxOrderValue}
                          MinOrderValue={this.state.MinOrderValue}
                          SubTotal={this.state.NonDisplaySubTotal}
                          Error={this.state.Error}
                          NavigateToPayMode={() => {
                            this.NavigateToPayMode();
                          }}
                          EmptyScheduleDnT={() => {
                            this.setState({
                              SheduleDescription: "",
                              VisibleSheduleOrder: true,
                              SheduleOpen: true,
                            });
                          }}
                          style={{ width: "100%", boxSizing: "border-box" }}
                        />
                      </div>
                    </div>
                  )}

                  {!this.state.isMerchantClosed ? (
                    ""
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          padding: "0 5px",
                          boxSizing: "border-box",
                        }}
                      >
                        <button
                          className="pgProductAddCartBtn"
                          style={{
                            fontSize: Font.MainHeading,
                            color: Colors.FontColor,
                            backgroundColor: "RED",
                            fontFamily: F_Fammily.Medium,
                            marginTop: "5px",
                            width: "100%",
                            boxSizing: "border-box",
                          }}
                          disabled={true}
                        >
                          MERCHANT CLOSED
                        </button>
                      </div>
                    </div>
                  )}

                  {this.state.VisibleSheduleOrder ? (
                    // this.state.CSP === "AV" ? (
                    //   <DrawerSheet
                    //     open={this.state.SheduleOpen}
                    //     displayCloseIcon="none"
                    //     Heading="Select Schedule Date & Time"
                    //     closeFunction={() =>
                    //       this.setState({ SheduleOpen: false })
                    //     }
                    //     element={
                    //       <DrawerShecule
                    //         SHeduleError={false}
                    //         SheduleMessage=""
                    //         dates={this.state.SheduleTimes}
                    //         MerchantAllowInstanceOrder={
                    //           this.state.MerchantAllowInstanceOrder
                    //         }
                    //         MinimumDate={this.state.SheduleMinimumDate}
                    //         NoOfDaystoshow={this.state.SheduleNoOfDaystoshow}
                    //         SelectedShedule={(date, time) => {
                    //           dto_common.SCHEDULEDDATE = date;
                    //           dto_common.SCHEDULEDTIME = time;
                    //           ENCRYPT_STORAGE.setItem(STORE_SHEDULEDateNTime, {
                    //             date: date,
                    //             time: time,
                    //           });
                    //           this.setState({ SheduleOpen: false });
                    //         }}
                    //       />
                    //     }
                    //   />
                    // ) : (
                    <DrawerSheetBottom
                      open={this.state.SheduleOpen}
                      displayCloseIcon="block"
                      closeFunction={() =>
                        this.setState({ SheduleOpen: false })
                      }
                      Heading="Select Schedule Date & Time"
                      element={
                        <DrawerShecule
                          SHeduleError={false}
                          SheduleMessage=""
                          dates={this.state.SheduleTimes}
                          MerchantAllowInstanceOrder={
                            this.state.MerchantAllowInstanceOrder
                          }
                          MinimumDate={this.state.SheduleMinimumDate}
                          NoOfDaystoshow={this.state.SheduleNoOfDaystoshow}
                          SelectedShedule={(date, time) => {
                            dto_common.SCHEDULEDDATE = date;
                            dto_common.SCHEDULEDTIME = time;
                            ENCRYPT_STORAGE.setItem(STORE_SHEDULEDateNTime, {
                              date: date,
                              time: time,
                            });
                            this.setState({ SheduleOpen: false });
                          }}
                        />
                      }
                    />
                  ) : // )
                  null}
                </div>

                {/* {CSP === "AV" ? (
                  <DrawerSheet
                    open={this.state.PromoDrawerOpen}
                    Heading="Promo"
                    displayCloseIcon="block"
                    element={
                      this.state.PromoDrawerOpen ? (
                        <LaodAllPromo
                          PromoApply={async (rs) => {
                            await this.SetPromo(rs);
                          }}
                        />
                      ) : null
                    }
                    id="LaodAllPromoCloseButton"
                  />
                ) : ( */}
                <DrawerSheetBottom
                  Heading="PROMO"
                  open={this.state.PromoDrawerOpen}
                  displayCloseIcon="block"
                  element={
                    this.state.PromoDrawerOpen ? (
                      <LaodAllPromo
                        PromoApply={async (rs) => {
                          await this.SetPromo(rs);
                        }}
                      />
                    ) : null
                  }
                  id="LaodAllPromoCloseButton"
                />
                {/* )} */}
              </>
            )}
          </div>
        )}
      </div>
    );
  }
}
